import * as React from 'react'
import { useLayoutEffect, useState } from 'react'
import styles from './TableScrollIndicator.module.scss'

export type TableScrollIndicatorProps = {
  scrollRef: React.RefObject<HTMLDivElement>
  containerRef: React.RefObject<HTMLDivElement>
}

export const TableScrollIndicator: React.FC<React.PropsWithChildren<TableScrollIndicatorProps>> = (props) => {
  const { scrollRef, containerRef } = props
  const [contentLeft, setContentLeft] = useState<boolean>(false)
  const [contentRight, setContentRight] = useState<boolean>(false)

  const updateScrollStatus = () => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const scrollX = scrollRef.current!.scrollLeft
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const scrollRemaining = scrollRef.current!.scrollWidth - 16 - containerRef.current!.offsetWidth - scrollX
    setContentLeft(scrollX > 64 + 1)
    setContentRight(scrollRemaining > 60 + 1)
  }

  useLayoutEffect(() => {
    if (scrollRef.current) {
      const scrollingElement = scrollRef.current
      scrollingElement.addEventListener('scroll', updateScrollStatus)
      updateScrollStatus()
      return () => {
        scrollingElement.removeEventListener('scroll', updateScrollStatus)
      }
    }
  })

  return (
    <>
      {contentLeft && <div className={styles.tableScrollIndicatorLeft} />}
      {contentRight && <div className={styles.tableScrollIndicatorRight} />}
    </>
  )
}
